import accessWays from 'modules/parameters/access_ways/store/index'
import auth from 'modules/auth/store/index'
import company from 'modules/company/store/index'
import deal from 'modules/deals/components/show/store/index'
import global from './global/index'
import lead from 'modules/leads/components/show/store/index'
import lossReasons from 'modules/parameters/loss_reasons/store/index'
import packages from 'modules/parameters/packages/store/index'
import paymentMethods from 'modules/parameters/payment_methods/store/index'
import pipelines from 'modules/parameters/pipelines/store/index'
import productCategories from 'modules/parameters/product_categories/store/index'
import products from 'modules/parameters/products/store/index'
import profile from 'modules/profile/store/index'
import segments from 'modules/parameters/segments/store/index'
import sources from 'modules/parameters/sources/store/index'
import suppliers from 'modules/parameters/suppliers/store/index'
import teams from 'modules/parameters/teams/store/index'
import templates from 'modules/templates/store/index'

export default {
    accessWays,
    auth,
    company,
    deal,
    global,
    lead,
    lossReasons,
    packages,
    paymentMethods,
    pipelines,
    productCategories,
    products,
    profile,
    segments,
    sources,
    suppliers,
    teams,
    templates
}



// WEBPACK FOOTER //
// ./src/store/modules.js